import fontawesome from '@fortawesome/fontawesome';
import brands from '@fortawesome/fontawesome-free-brands';
import iconsSolid from '@fortawesome/fontawesome-free-solid';

fontawesome.library.add(brands, iconsSolid);



// WEBPACK FOOTER //
// ./src/lib/icons.js